import { Buffer } from 'buffer'

// なぜ: Vite（ブラウザ）には Node の `Buffer` グローバルが存在しない。
// csv-stringify など一部依存パッケージが `Buffer` を参照しており、未定義のままだと
// 「ミルシート明細一覧表(CSV)」「発注・ミルシートデータ(CSV)」のダウンロード実行時に
// 「Buffer is not defined」で落ちる（旧クライアントの client-old/src/lib/bufferPolyfill.ts と同じ問題・同じ対応。
// 詳細: docs/issues/20260830_08_csv-download-buffer-missing.md）。
// 副作用 import なので、他モジュールより先に実行されるよう main.tsx の先頭で読み込むこと。
// （`buffer` はビルトイン名のため vite.config.ts の resolve.alias で npm パッケージへ解決している）
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer
}
